import Notification from '@vizuaalog/bulmajs/src/plugins/notification.js';
import { i18n } from './i18n.js';

export type Message = {
    severity: 'danger'|'warning'|'success'|'info';
    message: string;
}

export const message = {

    container: document.getElementById('messages'),
    listenerInstalled: false,
    icons: {
        danger: 'fa-exclamation-triangle',
        info: 'fa-info-circle',
        warning: 'fa-exclamation-circle',
        success: 'fa-check-circle',
    },

    /**
     * displays a message to the user
     * @param severity
     * @param rawMsg
     * @param msgSubstitution
     * @param error
     */
    log(severity: string, rawMsg: string, msgSubstitution?: string, error?: Error): void {
        console.log(severity, rawMsg, msgSubstitution, error);

        if (typeof Notification === 'undefined') return;
        this.container.classList.remove('empty');
        this.registerListener();

        // translate
        let msg;

        if (i18n.has_translation(rawMsg)) {
            msg = i18n.t(rawMsg, msgSubstitution);
        } else {
            msg = rawMsg;
        }

        // add icon
        const header = `<div class='notification-header'><span class='icon'><i class='fas fa-2x ${this.icons[severity]}'></i></span></div>`;

        // add message
        const body = `<div class='notification-body'>${msg}</div>`;

        // build body
        msg = header + body;

        // show as notification
        (Notification(this.container) as any).notification({
            body: msg,
            color: severity,
            isDismissable: true,
            destroyOnDismiss: true,
        }, this.container).show();
    },

    /**
     * clears all messages
     */
    clear(): void {
        while (this.container.firstChild) {
            this.container.firstChild.remove();
        }
        this.container.classList.add('empty');
    },

    /**
     * clear all messages if clicking on container
     */
    registerListener(): void {
        if (this.listenerInstalled === true) return;

        this.container.addEventListener('click', () => {
            this.clear();
        });

        this.listenerInstalled = true;
    },
};
